module.exports = __webpack_public_path__ + "static/work9-13eca5f0ecc0b4f1073b58e393b91a79.jpg";